<div>
  <app-notification-container />
  <main class="main-content">
    <div>
      <router-outlet />
    </div>
  </main>
</div>
